import { IFormItemOptions, IFormSchema, ISchemaProvider, ValidationMark, ValidationEventType, } from '@wiberg/formbuilder';
import { IMoveAllActivitiesDto } from './IMoveAllActivitiesDto';
import { tpPropertyOptionsFactory as factory } from '../../../../../forms/_builders/tpPropertyOptionsFactory';
import { guid } from '../../../../../helpers/guid';
import { ResourceType } from '../../../../../Entities/ResourceType';
import { translate } from '../../../../../Locales/i18n/localizationService';

export const moveAllActivitiesSchema: ISchemaProvider<IMoveAllActivitiesDto> = {
    key: 'moveAllActivitiesSchema',
    getSchema: async (dynamicKey: "request" | "allocation" | "both"): Promise<IFormSchema<IMoveAllActivitiesDto>> => {
        return {
			options: {
				validation: {
					validationRules: {
						targetResourceId: {
							id: '3Ydwe',
							validationMark: ValidationMark.Required,
							validationRule: item => guid.isGuidNotEmpty(item.targetResourceId),
							validationMessage: translate.t("MoveAllAllocationsDto.TargetResourceRequired"),
							validateOn: ValidationEventType.Blur | ValidationEventType.Manual,
						}
					},
				},
				properties: {
					sourceResourceId: factory.resource({
						displayName: translate.t("MoveAllAllocationsDto.SourceResource"),
						disable: () => true,
						config: {
							nameField: "name",
							descriptionField: "email",
							resourceTypes: dynamicKey === "request" ? [ResourceType.Named, ResourceType.Generic, ResourceType.Team, ResourceType.Pool] : [ ResourceType.Named, ResourceType.Category ] //EnumEx.all(ResourceType)
						}
					}),
					targetResourceId: factory.resource({
						displayName: translate.t("MoveAllAllocationsDto.TargetResource"),
						config: {
							nameField: "name",
							descriptionField: "email",
							excludeInactive: true,
							matchOnRbs: dynamicKey === "request" ? false : true,
							resourceTypes: dynamicKey === "request" ? [ResourceType.Named, ResourceType.Generic, ResourceType.Team, ResourceType.Pool] : [ ResourceType.Named, ResourceType.Category ] //EnumEx.all(ResourceType)
						}
					}),
				},
			} as IFormItemOptions<IMoveAllActivitiesDto>,
		} as unknown as IFormSchema<IMoveAllActivitiesDto>;
    },
};
